export const LOGO_PNG = "https://rpg-launcher-media.fra1.cdn.digitaloceanspaces.com/logo.png";